import { Section as S } from 'components/Section';
import styled from 'styled-components';

export const Section = styled(S)`
  position: relative;
  padding: 120px 0;

  @media (max-width: 576px) {
    padding: 10px 25px;
  }
  .grid p {
    letter-spacing: 1px;
    line-height: 22px;
    color: var(--text-color);
    margin: 20px 0 20px;
  }
`;
